import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { SourcesService } from './sources.service';

@Injectable({
  providedIn: 'root'
})
export class SourcesResolve implements Resolve<any> {

  constructor(
    private ss: SourcesService,
  ) { }

  resolve(route: ActivatedRouteSnapshot){
    return this.ss.updateSources(route.params)
  }
}
